import $ from 'jquery';
import _ from 'lodash-es';
import elementIsVisible from '../../core/INF-elementIsVisible';

const videosShouldPlay = () => {
  if (
    $('[data-site-overlay]').hasClass('SiteOverlay--active') ||
    $('[data-state]').hasClass('State--mobile-menu-open') ||
    $('[data-state]').hasClass('State--cart-open') ||
    $('[data-state]').hasClass('State--modal-open')
  ) {
    // Some kind of menu, modal, etc is open right now.  Don't play videos.
    return false;
  }

  return true;
};

export default function(players, type) {
  _.each(players, (player, player_id) => {
    const $player = $(`#${player_id}`);

    if (type === 'youtube' && !player.playVideo) {
      return;
    }

    if (type === 'vimeo' && !player.play) {
      return;
    }

    if (elementIsVisible($player) && !$player.data('manuallyPaused') && videosShouldPlay()) {
      if (type === 'youtube') {
        player.playVideo();
      } else {
        player.play();
      }      
    } else if (type === 'youtube') {
      player.pauseVideo();
    } else {
      player.pause();
    }
  });
}